<script>
  import { map } from 'lodash'

  export default {
    name: 'AppHeaderMini',
    computed: {
      countries_id() {
        return map(this.$store.state.players.all, 'country_iso_3')
      }      
    }
  }
</script>

<template>
  <div class="app-header-mini">
    <BContainer>
      <BRow class="justify-content-center">
        <BCol cols="12" md="3" class="player-item pl-0 text-center">
          <h1 class="app-header-mini__project">
            <RouterLink :to="{ name: 'list' }">
              <span>{{ $t('list.pre_title') }}</span>
              {{ $t('list.title') }}
            </RouterLink>
          </h1>
        </BCol>
      </BRow>
      <BRow class="justify-content-center">
        <BCol cols="8" md="3" class="player-item pr-0">
          <div class="app-header-mini__logo d-flex">
            <RouterLink :to="{ name: 'home.embed' }">
              <img alt="$config.get('app.name')" src="../assets/pp_logo.png" />
            </RouterLink>            
          </div>
        </BCol>
      </BRow>
    </BContainer>
  </div>
</template>

<style lang="scss" scoped>
  .app-header-mini {
    position: relative;
    margin-bottom: 30px;
    padding: 15px 0;
    z-index: 9;

    &__group {
      width: 100%;
      max-width: 720px;
      opacity: 0;
      animation: logoUp 1.2s forwards 1 ease-in-out;
    }

    .image-cover {
      width: 65%;
      opacity: 0.7;
    }

    &__logo {
      img {
        width: 100%;
      }
    }

    &__project {      
      color: var(--app-color-black);
      font-family: var(--headings-type-writer);
      font-size: 18px;
      margin: 0;
      animation: 
        typing 3.5s steps(40, end),
        blink-caret .75s step-end infinite;

      span {
        display: block;
        font-size: 12px
      }

      a {
        color: inherit;
        text-decoration: none;
      }
    }

    &__intro {
      color: var(--app-color-black);
      font-size: 1.4em;
      text-align: center;
    }

    &__project {
      font-weight: bold;
    }

    &__app {
      font-weight: normal;
    }

    @keyframes logoUp {
      to {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
</style>
